export const createLinkTag = (rel: string, href: string, crossOrigin: string) => {
  const link = document.createElement('link');

  link.setAttribute('rel', rel);
  link.setAttribute('href', href);
  link.setAttribute('crossorigin', crossOrigin);

  return link;
};
